import { createContext } from 'react';

export type IDashboardContext = {
  asideElement: HTMLDivElement | null;
};

export const DashboardContext = createContext<IDashboardContext | undefined>({
  asideElement: null,
});
